document.addEventListener('DOMContentLoaded', () => {
  const MODAL_SEL = 'product-modal.product-media-modal[open]';
  const CONTENT_SEL = '.product-media-modal__content';

  const getModal = () => document.querySelector(MODAL_SEL);
  const getContent = (m) => m?.querySelector(CONTENT_SEL);

  // نحاول نلتقط كل media blocks اللي اتعملها render من snippet 'product-media'
  // في Dawn/Rise غالباً بيكون عليها data-media-id أو role=dialog content children
  const collectItems = (content) => {
    const byId = Array.from(content.querySelectorAll('[data-media-id]'));
    if (byId.length) return byId;

    // fallback: أولاد مباشرة (بس فلتر العناصر الفاضية)
    return Array.from(content.children).filter(el => el.querySelector('img,video,model-viewer,iframe'));
  };

  const ensureUI = (content, total) => {
    if (content.querySelector('.zk-mm-stage')) return;

    const stage = document.createElement('div');
    stage.className = 'zk-mm-stage';

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'zk-mm-nav zk-mm-nav--prev';
    prev.textContent = '‹';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'zk-mm-nav zk-mm-nav--next';
    next.textContent = '›';

    const counter = document.createElement('div');
    counter.className = 'zk-mm-counter';
    counter.textContent = `1 / ${total}`;

    const spinner = document.createElement('div');
    spinner.className = 'zk-mm-spinner';

    content.prepend(stage);
    content.appendChild(prev);
    content.appendChild(next);
    content.appendChild(counter);
    stage.appendChild(spinner);
  };

  const setActive = (items, index, content) => {
    const total = items.length;
    if (!total) return 0;
    index = (index + total) % total;

    // hide all
    items.forEach(el => el.classList.remove('is-active'));
    // show one
    const active = items[index];
    active.classList.add('is-active');

    // move it inside stage
    const stage = content.querySelector('.zk-mm-stage');
    if (stage && active.parentNode !== stage) stage.appendChild(active);

    // update counter
    const counter = content.querySelector('.zk-mm-counter');
    if (counter) counter.textContent = `${index + 1} / ${total}`;

    // spinner on while active img loads (only if it's an img)
    const spinner = content.querySelector('.zk-mm-spinner');
    const img = active.querySelector('img');
    if (spinner && img) {
      spinner.classList.add('is-on');
      const done = () => spinner.classList.remove('is-on');
      if (img.complete) done();
      else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    } else if (spinner) {
      spinner.classList.remove('is-on');
    }

    // reset zoom state when changing slide
    content.classList.remove('zk-mm-zoomed');
    content.style.setProperty('--zk-scale', '1');
    content.style.setProperty('--zk-x', '0px');
    content.style.setProperty('--zk-y', '0px');

    return index;
  };

  const attachZoomPan = (content) => {
    if (content.dataset.zkZoomBound === '1') return;
    content.dataset.zkZoomBound = '1';

    let scale = 1, x = 0, y = 0;
    let lastTap = 0;
    let dragging = false, px = 0, py = 0;

    const apply = () => {
      content.style.setProperty('--zk-scale', String(scale));
      content.style.setProperty('--zk-x', `${x}px`);
      content.style.setProperty('--zk-y', `${y}px`);
    };

    content.addEventListener('pointerup', (e) => {
      const img = content.querySelector('.zk-mm-item.is-active img');
      if (!img || !e.target.closest('img')) return;

      const now = Date.now();
      const dbl = now - lastTap < 300;
      lastTap = now;
      if (!dbl) return;

      if (scale < 1.2) {
        scale = 2.6;
        x = 0; y = 0;
        content.classList.add('zk-mm-zoomed');
      } else {
        scale = 1; x = 0; y = 0;
        content.classList.remove('zk-mm-zoomed');
      }
      apply();
    }, { passive: true });

    content.addEventListener('pointerdown', (e) => {
      if (scale <= 1.05) return;
      if (!e.target.closest('img')) return;
      dragging = true;
      px = e.clientX; py = e.clientY;
    });

    content.addEventListener('pointermove', (e) => {
      if (!dragging || scale <= 1.05) return;
      const dx = e.clientX - px;
      const dy = e.clientY - py;
      px = e.clientX; py = e.clientY;
      x += dx; y += dy;
      apply();
    }, { passive: true });

    content.addEventListener('pointerup', () => { dragging = false; }, { passive: true });
    content.addEventListener('pointercancel', () => { dragging = false; }, { passive: true });
  };

  const attachNav = (content, items) => {
    if (content.dataset.zkNavBound === '1') return;
    content.dataset.zkNavBound = '1';

    let index = 0;

    const prev = content.querySelector('.zk-mm-nav--prev');
    const next = content.querySelector('.zk-mm-nav--next');

    const go = (dir) => { index = setActive(items, index + dir, content); };

    prev?.addEventListener('click', () => go(-1));
    next?.addEventListener('click', () => go(1));

    // wheel (desktop) — only if not zoomed
    content.addEventListener('wheel', (ev) => {
      if (content.classList.contains('zk-mm-zoomed')) return;
      ev.preventDefault();
      go(ev.deltaY > 0 ? 1 : -1);
    }, { passive: false });

    // swipe (mobile) — only if not zoomed
    let sx = 0, sy = 0, tracking = false;

    content.addEventListener('touchstart', (e) => {
      if (content.classList.contains('zk-mm-zoomed')) return;
      const t = e.touches?.[0]; if (!t) return;
      tracking = true; sx = t.clientX; sy = t.clientY;
    }, { passive: true });

    content.addEventListener('touchend', (e) => {
      if (!tracking) return;
      tracking = false;
      if (content.classList.contains('zk-mm-zoomed')) return;

      const t = e.changedTouches?.[0]; if (!t) return;
      const dx = t.clientX - sx;
      const dy = t.clientY - sy;

      if (Math.abs(dx) < 35 || Math.abs(dx) < Math.abs(dy)) return;
      go(dx < 0 ? 1 : -1);
    }, { passive: true });

    // init first
    index = setActive(items, 0, content);
  };

  const initModal = () => {
    const modal = getModal();
    if (!modal) return;

    const content = getContent(modal);
    if (!content) return;

    // جمع العناصر
    const items = collectItems(content);
    if (!items.length) return;

    // ضع class موحد على كل عنصر
    items.forEach(el => el.classList.add('zk-mm-item'));

    ensureUI(content, items.length);
    attachZoomPan(content);
    attachNav(content, items);
  };

  // عند فتح المودال (click على زر الزوم أو الصورة)
  document.addEventListener('click', () => {
    requestAnimationFrame(() => requestAnimationFrame(initModal));
  }, true);
});
